import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './navbar.css';
import {
  Navbar as BsNavbar,
  Nav,
  NavDropdown,
  Button,
  Col,
  Container,
} from 'react-bootstrap';
import LogoText from '../../assets/images/logo-with-text-64px.png';
import LogoIcon from '../../assets/images/logo-simple-32px.png';

interface NavbarProps {
  isMobile: boolean;
  isTablet: boolean;
}

const Navbar = ({ isMobile }: NavbarProps) => {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const navigateToSection = (sectionId: string) => {
    setExpanded(false);
    console.log('location.pathname', location.pathname);

    if (
      location.pathname == '/' ||
      // Internachi discounted price page
      location.pathname == '/InterNACHI-discount-ji394su3pa7/'
    ) {
      // Already on homepage or Internachi discounted price page, just scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // If not on homepage, navigate to homepage first
      navigate('/');
      // Schedule a scroll after navigation
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  const features = [
    { title: 'AI Issue Analysis', id: 'ai-analysis' },
    { title: 'Seamless Note-Taking', id: 'note-taking' },
    { title: 'Annotated Photo Detection', id: 'photo-detection' },
    { title: 'Real Time Report Building', id: 'report-building' },
    { title: 'Smart Template', id: 'smart-template' },
    { title: 'Sample Report', id: 'sample-report' },
  ];

  return (
    <BsNavbar
      expand="md"
      className="navbar"
      fixed="top"
      expanded={expanded}
      onToggle={setExpanded}
    >
      <Container className="d-flex justify-content-between align-items-center">
        <BsNavbar.Brand
          onClick={() => navigateToSection('home')}
          className="navbar-brand-wrapper"
          style={{ cursor: 'pointer' }}
        >
          <picture>
            <source media="(max-width: 1199px)" srcSet={LogoIcon} />
            <img src={LogoText} alt="Morph" height={32} />
          </picture>
        </BsNavbar.Brand>
        <BsNavbar.Toggle aria-controls="basic-navbar-nav" className="ms-2" />

        <div className="navbar-inner">
          {/* Main navigation container */}
          <Col xl={6} sm={8} className="main-nav-container">
            <BsNavbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                <NavDropdown
                  title="Features"
                  id="features-dropdown"
                  show={isMobile || undefined}
                >
                  {features.map((feature) => (
                    <NavDropdown.Item
                      key={feature.id}
                      onClick={() => navigateToSection(feature.id)}
                    >
                      {feature.title}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
                <Nav.Link onClick={() => navigateToSection('pricing')}>
                  Pricing
                </Nav.Link>
                <Nav.Link onClick={() => navigateToSection('about')}>
                  About
                </Nav.Link>
                <Nav.Link
                  style={{ textDecoration: 'none', color: 'inherit' }}
                  href="mailto:help@morph-technologies.com"
                >
                  Contact
                </Nav.Link>
              </Nav>
            </BsNavbar.Collapse>
          </Col>
          <Col
            xl={6}
            sm={4}
            className={`join-waitlist-btn-wrapper ${expanded ? 'show' : ''}`}
          >
            <a
              href={`${process.env.REACT_APP_WEB_APP_URL || 'https://app.morph-technologies.com'}/login`}
              className="login-link"
            >
              <Button variant="outline-primary" className="login-btn">
                Login
              </Button>
            </a>
            <Nav.Link onClick={() => navigateToSection('download')}>
              <Button variant="primary" className="join-waitlist-btn">
                Get Started
              </Button>
            </Nav.Link>
          </Col>
        </div>
      </Container>
    </BsNavbar>
  );
};

export default Navbar;
